import { render, staticRenderFns } from "./shoolmanage.vue?vue&type=template&id=58767954&scoped=true"
import script from "./shoolmanage.vue?vue&type=script&lang=js"
export * from "./shoolmanage.vue?vue&type=script&lang=js"
import style0 from "./shoolmanage.vue?vue&type=style&index=0&id=58767954&prod&lang=less"
import style1 from "./shoolmanage.vue?vue&type=style&index=1&id=58767954&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58767954",
  null
  
)

export default component.exports